var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDistributed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47266 2.1124H9.52734V3.16708H8.47266V2.1124Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.14453 7.42099H3.19922V8.47568H2.14453V7.42099Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6914 7.42099H10.582V10.4786L9.52734 9.77547V5.27646H11.6367V0.00302124H6.36328V5.27646H8.47266V9.77547L7.41797 10.4786V7.42099H5.30859V5.31161H0V10.5851H5.30859V8.47568H6.36328V11.1817L5.30859 11.8848V15.536L9 17.997L12.6914 15.536V11.8848L11.6367 11.1817V8.47568H12.6914V10.5851H18V5.31161H12.6914V7.42099ZM7.41797 1.05771H10.582V4.22177H7.41797V1.05771ZM4.25391 9.53036H1.05469V6.3663H4.25391V9.53036ZM9 13.6427L6.78663 12.1671L9 10.6915L11.2134 12.1671L9 13.6427ZM6.36328 13.1524L8.47266 14.5587V16.3778L6.36328 14.9716V13.1524ZM9.52734 16.3778V14.5587L11.6367 13.1524V14.9716L9.52734 16.3778ZM13.7461 6.3663H16.9453V9.53036H13.7461V6.3663Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8008 7.42099H15.8555V8.47568H14.8008V7.42099Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistributed);
export default __webpack_public_path__ + "static/media/distributed.3c629256fddad63a823089e799efbc29.svg";
export { ForwardRef as ReactComponent };